import React, {useEffect, useState} from "react";
import ReactExport from "react-export-excel-fixed-xlsx";
import {useTranslation, withTranslation} from "react-i18next";
import {Button} from "antd";
import _ from "lodash";
import moment from "moment";

import {FileExcelOutlined} from "@ant-design/icons";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function DownloadExcel(props) {
    const {tipoInforme} = props;
    const {t, i18n} = useTranslation();
    const [dataSet1, setDataSet1] = useState([]);
    const [dataSet2, setDataSet2] = useState([]);

    const [multiData, setMultiData] = useState(null)


    useEffect(() => {



    }, [props])

    return (


        <>        
        {props.dataExcel && props.dataExcel.length > 0 &&
                <ExcelFile filename={"Excel" + moment().format(("YYYYMMDDHHMMSS")) + ".xls"}
                           element={<Button icon={<FileExcelOutlined/>} className={"btnWhiteBlue"}>{t("datos.axls")}
                           </Button>}>
                    <ExcelSheet data={props.dataExcel} name="Informe">
                        <ExcelColumn label="Fecha Creación" value="createdAt"/>
                        <ExcelColumn label="Identificador" value="identifier"/>
                        <ExcelColumn label="CodCentro" value="center"/>
                        <ExcelColumn label="Último acceso" value="updatedAt"/>
                        <ExcelColumn label="edad" value="age"/>
                        <ExcelColumn label="curso" value="course"/>
                        <ExcelColumn label="grupo" value="group"/>
                        <ExcelColumn label="totalMinutes" value="totalMinutes"/>
                        <ExcelColumn label="CBP1EXP23" value="CBP1EXP23"/>
                        <ExcelColumn label="CBP2ING23" value="CBP2ING23"/>
                    </ExcelSheet>
                </ExcelFile>
            }
        </>
    );
}

export default withTranslation()(DownloadExcel);
